import { ColumnHeader } from "@/components/data-table/ColumnHeader";
import TooltipHover from "@/components/ui/TooltipHover";
import { CopyButton } from "@/components/ui/copyButton";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { APIKey } from "../../types/app.type";
import APIKeyActions from "./APIKeyActions";
import APIKeyValueCell from "./APIKeyValueCell";

const columnHelper = createColumnHelper<APIKey>();

export const apiKeysColumns: ColumnDef<APIKey>[] = [
  {
    accessorKey: "name",
    cell: ({ row }) => (
      <TooltipHover text={row.getValue("name")} placement="bottom" asChild>
        <span>{row.getValue("name")}</span>
      </TooltipHover>
    ),
    header: ({ column }) => <ColumnHeader column={column} title="Name" />,
    enableGlobalFilter: true,
    enableHiding: false
  },
  {
    accessorKey: "value",
    cell: ({ row }) => <APIKeyValueCell apiKey={row.getValue("value")} />,
    header: ({ column }) => <ColumnHeader column={column} title="API Key" />,
    enableGlobalFilter: true,
    enableHiding: false
  },
  columnHelper.display({
    id: "copyAction",
    cell: ({ row }) => (
      <CopyButton variant="ghost" copyText={row.getValue("value")} />
    )
  }),
  columnHelper.display({
    id: "APIKeyActions",
    cell: ({ row }) => (
      <div className='invisible group-hover:visible [&>button[data-state="open"]]:visible'>
        <APIKeyActions apiKey={row.original} />
      </div>
    )
  })
];
